<template>
    <div class="colors-view ">
        <form @submit.prevent>
            <active-palette>
                <div class="confirmation-buttons">
                    <save-button/>
                    <reset-button/>
                </div>
            </active-palette>
            <color-picker/>
        </form>
    </div>
</template>

<script>
    import BaseView    from '../../../App/Views/BaseView';
    import ColorPicker from "./Components/ColorPicker/ColorPicker";
    import SwatchForm    from "../SwatchForm";
    import ActivePalette from "./Components/Palette/ActivePalette";
    import Transition    from "../../../Lib/Objects/Transition";
    import SaveButton  from "./Components/ColorPicker/SaveButton";
    import ResetButton from "./Components/ColorPicker/ResetButton";

    export default {
        extends: BaseView,
		components: {ResetButton, SaveButton, ActivePalette, ColorPicker},
		
        data() {
            return {
                title: "Colors",
                newColor: {},
                form: new SwatchForm(),
            }
        },

        mounted() {
            new Transition('.fade-in-up', 0.5).fadeInUp(32);
        },
    }
</script>
